exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal-dialog[data-v-701ac82d] {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  margin: 0;\n  transform: translate(-50%, -50%) !important;\n}\n.modal-body .modal-form[data-v-701ac82d] {\n  min-height: 0;\n  padding-bottom: 0;\n  overflow-y: auto;\n}\n.modal-body .btn-box[data-v-701ac82d] {\n  position: absolute;\n  bottom: 15px;\n  right: 15px;\n}\n.modal-body.show-btn[data-v-701ac82d] {\n  padding-bottom: 65px;\n}\n.el-message-box__close[data-v-701ac82d] {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  padding: 0;\n  border: none;\n  outline: 0;\n  background: 0 0;\n  font-size: 16px;\n  cursor: pointer;\n  color: #909399;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-701ac82d","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Modal.vue
// module id = 1996
// module chunks = 0